/*
  Shown when the backend reports a backing service (e.g. the Njord article /
  invoicing service) is unreachable — a 503 from the api-client error mixins.
 */
export const SERVICE_UNAVAILABLE_MESSAGE =
  'The article service is currently unavailable. Please try again later.'

/*
  Flatten a DRF/Django error payload into a flat list of message strings.

  Handles a plain string, an array, an object with a `detail` key, and the
  field-keyed dict ({ state: ['...'] }) that django-filter and DRF serializers
  return — so validation errors never render as '[object Object]'.
 */
export function extractErrorMessages (data) {
  if (data === null || data === undefined) {
    return []
  }
  if (typeof data === 'string') {
    return [data]
  }
  if (Array.isArray(data)) {
    let messages = []
    for (let item of data) {
      messages = messages.concat(extractErrorMessages(item))
    }
    return messages
  }
  if (typeof data === 'object') {
    if (data.detail) {
      return extractErrorMessages(data.detail)
    }
    let messages = []
    for (let key of Object.keys(data)) {
      messages = messages.concat(extractErrorMessages(data[key]))
    }
    return messages
  }
  return [String(data)]
}
